import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { CheckboxInput } from '../../../models';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-checkbox-input',
    standalone: true,
    imports: [CheckboxModule, FormsModule, ReactiveFormsModule],
    template: `
        <div class="d-block">
            <p-checkbox
                inputId="{{ 'input-' + name }}"
                [class]="control.inputClass.join(' ')"
                [formControl]="control"
                [binary]="true"
            ></p-checkbox>
            <label for="{{ 'input-' + name }}" class="ml-2">{{ control.label }}</label>
        </div>
    `
})
export class CheckboxInputComponent extends BaseInputComponent<string> {
    @Input() name!: string;
    @Input() override control!: CheckboxInput;
}
